export default __webpack_public_path__ + "static/media/team-illustration-3.48c22673.svg";